<template>
  <div id="dixin_jiangli">
    <div class="stage1">
      <p class="stage1-title">奖励明细</p>
      <p class="line flex-box">
        当前直播时长
        <span>
          <i :style="{width:(complete_val*1/(showtime*1)*100) + '%'}"></i>
        </span>
        {{ complete_val }}/{{ showtime }}小时
      </p>

      <div v-for="(n, index) in list" :key="index">
        <p class="stage1-title">
          {{ n.title }}
          <span>奖励</span>
        </p>
        <p v-for="(x, zx) in n.down" :key="zx">
          {{ x.msg }}
          <i v-if="x.price == '暂无'">{{ x.price }}</i>
          <i v-else>{{ x.price }}</i>
        </p>
      </div>
    </div>
  </div>
</template>





















<script>
export default {
  name: "dixin_jiangli",
  props: ["list", "showtime", "complete_val"],
  data() {
    return {
    };
  },
  methods: {},
  computed: {},
  mounted: function() {}
};
</script>



















<style scoped>
/**第一阶段 */
.stage1 {
  padding: 12px 16px;
  padding-top: 0;
  background: rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  overflow: hidden;
  margin-top: 9px;
}
.stage1 p {
  clear: both;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 5px;
  align-items: center;
}
.stage1 .stage1-title {
  font-size: 14px;
  color: white;
  margin-top: 13px;
}
.stage1-title span {
  float: right;
  font-size: 12px;
}
.stage1 p > i {
  font-style: normal;
  font-size: 14px;
  color: white;
  float: right;
  font-weight: bold;
}
.stage1 .line span {
  display: inline-block;
  position: relative;
  height: 6px;
  border-radius: 25px;
  width: 47%;
  margin: 0 12px;
  background: rgba(0, 0, 0, 0.16);
}
.stage1 .line i {
  transition: all 0.6s;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 25px;
  background: linear-gradient(to right, #ffe544, #ffaa34);
}
</style>

